<app-stream-details
  [deliverableForm]="deliverableForm()"
  [deliverableId]="deliverableId()"
  [deliverableType]="deliverableType()"
  [executionAnalytics]="executionAnalytics()"
  [platformFeature]="platformFeature()"
  [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
>
  @if (deliverableType() === EDeliverableType.description) {
    <app-description-stream-analytics
      [deliverableForm]="deliverableForm()"
      [deliverableId]="deliverableId()"
      [executionAnalytics]="executionAnalytics()"
      [platform]="platform()"
      [timelineData]="[]"
      [viewerGraphData]="[]"
      [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
    />
  }
</app-stream-details>
